// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ReconciliationFilledSvg from "@fishx/icons-svg/es/asn/ReconciliationFilled";
import FishxIcon from '../components/FishxIcon';

var ReconciliationFilled = function ReconciliationFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ReconciliationFilledSvg
  }));
};

ReconciliationFilled.displayName = 'ReconciliationFilled';
export default React.forwardRef(ReconciliationFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ReconciliationFilled.js
// module id = 3978
// module chunks = 0